import { render, staticRenderFns } from "./SkillConfigDetailDialog.vue?vue&type=template&id=2ddce05a&scoped=true&"
import script from "./SkillConfigDetailDialog.vue?vue&type=script&lang=js&"
export * from "./SkillConfigDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./SkillConfigDetailDialog.vue?vue&type=style&index=0&id=2ddce05a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddce05a",
  null
  
)

export default component.exports